import { render, staticRenderFns } from "./kycView.vue?vue&type=template&id=4425ae22&scoped=true&"
import script from "./kycView.vue?vue&type=script&lang=js&"
export * from "./kycView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4425ae22",
  null
  
)

export default component.exports